 @let activity = $activity();
 <!-- {} -->
 <!-- {} -->

 @if (!$nested()) {

 @if (activity?.threadId && activity?.threadId !== activity?._id) {
     <div class="thread-indicator"></div>
 }

 <div class="activity-timeline">

     <div class="kind-container">


         <div class="line-container" [ngClass]="activity?.system ? 'system' : 'user'">
             <div class="item"></div>
             <div class="item line"></div>
         </div>


         @if (!activity?.system && $isClaims()) {
             <div class="selection">
                 <w-checkbox [disabled]="!$canSelect()" [checked]="$safeNavigationMigration(selectionService?.isSelected($safeNavigationMigration(activity?._id)))" (onCheck)="$event ? selectionService.select($safeNavigationMigration(activity?._id)) : selectionService.deselect($safeNavigationMigration(activity?._id))" />
             </div>
         }

         <div class="kind">
             <i class="fa-regular" [ngClass]="activity | activityKind" [ngStyle]="{color: activity | activityKindColor }"></i>
         </div>

         @if (isLast) {
             <div class="line-container">
                 <div class="item"></div>
                 <div class="item"></div>
             </div>
         } @else {
             <div class="line-container">
                 <div class="item"></div>
                 <div class="item line"></div>
             </div>
         }


     </div>

 </div>

 <div class="activity-content-container" [ngClass]="{system: $safeNavigationMigration(activity?.system), active: $safeNavigationMigration(selectionService?.isSelected($safeNavigationMigration(activity?._id)))}">

     <!-- Above the system split: integration-raised threads (e.g. HomesVIC memo streams) are system roots and get resolved upstream. -->
     @if ($isThreadRoot() && activity?.kind === 'Thread' && $isThreadResolved()) {
         <div class="thread-resolved-indicator top">
             <i class="fa-regular fa-circle-check"></i>
             <span>Thread resolved</span>
         </div>
     }

     @if (activity?.system) {

         <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
         <div class="info-container">
             <div class="info-row">
                 @if (activity?.createdBy?.name; as createdBy) {
                     <div class="created-by info" [innerText]="createdBy"></div>
                 }
                 <div class="time info" [innerText]="(activity?.createdDate ?? activity?.updateDate) | timezoneTime:$safeNavigationMigration($context()?.timezone)"></div>
                 @if ($jobEntityName()) {
                     <div class="entity-name info" [innerText]="$jobEntityName()"></div>
                 }
                 @if ($workOrderEntityName()) {
                     <div class="entity-name info" [innerText]="$workOrderEntityName()"></div>
                 }
             </div>
         </div>

     } @else {

         <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
         <w-divider orientation="horizontal" />

         <div class="info-container">
             <div class="info-row">
                 @if (activity?.isDraft === true) {
                     <div class="info tags">
                         <span class="draft-activity-label">Incomplete</span>
                     </div>
                 }
                 @if (activity?.createdBy?.name; as createdBy) {
                     <div class="created-by info" [innerText]="createdBy"></div>
                 }
                 @if ($isThreadChild()) {
                     <div class="time info" [innerText]="(activity?.createdDate ?? activity?.updateDate) | timezoneDate:$safeNavigationMigration($context()?.timezone):true"></div>
                 } @else {
                     <div class="time info" [innerText]="(activity?.createdDate ?? activity?.updateDate) | timezoneTime:$safeNavigationMigration($context()?.timezone)"></div>
                 }
                 @if (activity?.updateBy?.name) {
                     <div class="edited info" [title]="'Edited on ' + ($safeNavigationMigration(activity?.updateDate) | timezoneDate:$safeNavigationMigration($context()?.timezone):true)">Edited</div>
                 }
                 @if ($workOrderEntityName()) {
                     <div class="entity-name info" [innerText]="$workOrderEntityName()"></div>
                 }
             </div>
         </div>

         <!-- Include $supportsSharing() so locked kinds (e.g. sent SMS, which can't be edited/deleted) still render their sharing label; the inner sharing-pro stays read-only via [readonly]="!$canShare()". -->
         @if ($canShare() || $canEdit() || $canDelete() || $supportsSharing()) {
             <div class="action-container">
                 <div class="left">
                     @if ($supportsSharing()) {
                         <sharing-pro [readonly]="!$canShare()" [value]="$safeNavigationMigration(activity?.effectiveSharing)" menuAlignment="Left" size="Small" (onChange)="onShare($event)" />
                     }
                 </div>
                 <div class="right">
                     @if ($canEdit() || $canDelete() || $canShare()) {
                         <w-button mode="Menu" iconLeft="fa-regular fa-ellipsis" iconRight="" size="Small" [commands]="$commands()" [disabled]="!$canEdit()" />
                     }
                 </div>
             </div>
         }
     }

     @if ($isThreadRoot() && activity?.kind === 'Thread') {

         @if ($threadChildren()?.length) {
             <w-divider orientation="horizontal" />
             <div class="thread-replies">
                 @for (child of $threadChildren(); track child._id) {
                     <activity-item [nested]="true" [context]="$context()" [activity]="child" (edit)="edit.emit($event)" (delete)="delete.emit($event)" (share)="share.emit($event)" />
                 }
             </div>
         }

         @if ($threadCollapsible()) {
             <div class="thread-expander" (click)="onToggleThread()">
                 @if ($hiddenChildCount() > 0) {
                     <span>All activities</span>
                     <i class="fa-regular fa-chevron-down"></i>
                 } @else {
                     <span>Show less</span>
                     <i class="fa-regular fa-chevron-up"></i>
                 }
             </div>
         }

         @if (!$isThreadResolved()) {
             <div class="thread-reply-container">
                 <input type="text" class="thread-reply-input" placeholder="Reply to thread..." [(ngModel)]="threadReplyText" (keydown.enter)="sendThreadReply()" [disabled]="threadReplying" />
                 <button class="thread-reply-expand" (click)="openFullReplyDialog()" [disabled]="threadReplying" title="Open full editor with attachments">
                     <i class="fa-regular fa-paperclip"></i>
                 </button>
                 <button class="thread-reply-send" (click)="sendThreadReply()" [disabled]="threadReplying || !threadReplyText?.trim()">
                     <i class="fa-regular fa-paper-plane-top"></i>
                 </button>
             </div>
         }
     }

 </div>

 } @else {

     <div class="activity-content-container nested">
         <div class="nested-header">
             <div class="info-container">
                 <div class="info-row">
                     @if (activity?.createdBy?.name; as createdBy) {
                         <div class="created-by info" [innerText]="createdBy"></div>
                     }
                     <div class="time info" [innerText]="(activity?.createdDate ?? activity?.updateDate) | timezoneDate:$safeNavigationMigration($context()?.timezone):true"></div>
                     @if (activity?.updateBy?.name) {
                         <div class="edited info" [title]="'Edited on ' + ($safeNavigationMigration(activity?.updateDate) | timezoneDate:$safeNavigationMigration($context()?.timezone):true)">Edited</div>
                     }
                 </div>
             </div>
             @if ($canEdit() || $canDelete()) {
                 <w-button mode="Menu" iconLeft="fa-regular fa-ellipsis" iconRight="" size="Small" [commands]="$commands()" [disabled]="!$canEdit()" />
             }
         </div>
         <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
     </div>

 }

 <ng-template #contentTemplate>


     @if(activity?.name && activity.kind !== 'Email') {
         <div class="name info">
             <span [ngClass]="$safeNavigationMigration(activity?.kind)" [innerHTML]="$safeNavigationMigration(activity?.name) | sanitizeHtml" [title]="getPlainText($safeNavigationMigration(activity?.name))"></span>
         </div>
     }

     @switch(activity.kind) {
         @case('Email') {

             <ng-container *ngTemplateOutlet="status"></ng-container>

             <div class="activity-header">

                 @if(activity?.to?.length) {
                     <div class="key-value">
                         <div class="key">To:</div>
                         <div class="value">{{ activity.to | emailContacts }}</div>
                     </div>
                 }

                 @if(activity?.cc?.length) {
                     <div class="key-value">
                         <div class="key">Cc:</div>
                         <div class="value">{{ activity.cc | emailContacts }}</div>
                     </div>
                 }

                 @if(activity?.bcc?.length) {
                     <div class="key-value">
                         <div class="key">Bcc:</div>
                         <div class="value">{{ activity.bcc | emailContacts }}</div>
                     </div>
                 }

                 @if(activity?.name) {
                     <div class="key-value">
                         <div class="key">Subject:</div>
                         <div class="value" [innerHTML]="activity.name | sanitizeHtml"></div>
                     </div>
                 }


             </div>

         }

         @case('SMS') {

             <ng-container *ngTemplateOutlet="status"></ng-container>

             <div class="activity-header">

                 @if(activity?.from) {
                     <div class="key-value">
                         <div class="key">From:</div>
                         <div class="value">{{ [activity.from] | smsContacts }}</div>
                     </div>
                 }

                 @if(activity?.to?.length) {
                     <div class="key-value">
                         <div class="key">To:</div>
                         <div class="value">{{ activity.to | smsContacts }}</div>
                     </div>
                 }

             </div>


         }

     }


     @if(activity?.subTitle; as subTitle) {
         <div class="sub-title" [innerHTML]="subTitle | sanitizeHtml"></div>
     }

     @if (activity?.note; as note) {
         <div class="note" [innerHTML]="note"></div>
     }

     @if (activity?.kind === 'Phone') {
         <div class="note">
             {{formatCallLogDetails()}}
         </div>
     }

     @if ($attachments()?.length) {
          @if (activity?.isDraft && activity?.kind === 'Form') {
              @if($canContinueForm()) {
                  <w-button displayStyle="Primary" size="Medium" label="Continue filling in the form" buttonClass="form-fill-button" (onClick)="onEditForm()"></w-button>
              } @else if (!$formStageAvailable()) {
                  <div class="form-unavailable-message">This form cannot be continued because the related stage was deleted.</div>
              }
          } @else {
             @if (!activity?.isDraft) {
                 <attachments [overrideGridTemplateColumns]="$overrideTemplateColumns()" [deletable]="false" [selectable]="false" [showMetadata]="false" [showTags]="false" [attachments]="$attachments()" [gridGap]="'8px'" [gridLimit]="5" [ngStyle]="$getAttachmentsStyle()" (itemClicked)="onPreview($event)" [alternativeDownload]="activity.kind === ActivityKind.Form" (downloadClicked)="downloadFormPDF()" />
             }
         }
     }

     <!-- <div class="info-container">
  <div class="info-row">
    <div class="entity-name info" [innerText]="$workOrderEntityName()" *ngIf="$workOrderEntityName()"></div>
  </div>
</div> -->

     @if (activity?.labels?.length) {
         <div class="w-badge-wrapper">
             @for (label of activity?.labels; track label) {
                 <w-badge mode="item" iconLeft="fa-solid fa-circle-small" [iconLeftColor]="label.color" [label]="label.name" />
             }
         </div>
     }
 </ng-template>

 <ng-template #status>

     @if ($sendStatusVisbile()) {
         <div class="activity-header">
             <div class="key-value">
                 <div class="value">
                     <w-badge [label]="$sendStatusDisplay()" [tooltip]="$sendStatusTooltip()" [mode]="'squared'" [size]="'xs'" [iconLeft]="$sendStatusIcon()" backgroundColor="white" />
                 </div>
             </div>
         </div>
     }

 </ng-template>
